// client/src/utils/warmPendingCache.js
const ss = typeof window !== 'undefined' ? window.sessionStorage : null;

function cacheSet(k, v){ try{ ss?.setItem(k, JSON.stringify(v)); }catch{} }
function cacheGet(k){ try{ const r=ss?.getItem(k); return r?JSON.parse(r):null; }catch{ return null; } }
const keyOf = (uid) => `INF_PENDING:${uid}`;
const readyKey = (uid) => `INF_PENDING_READY:${uid}`;

// 네트워크 수신(HTTP 캐시 채움)
async function prefetchFetch(urls = [], conc = 10) {
  const uniq = Array.from(new Set(urls.filter(Boolean)));
  let i = 0;
  while (i < uniq.length) {
    const chunk = uniq.slice(i, i + conc); i += conc;
    await Promise.all(chunk.map(u => fetch(u).catch(()=>{})));
  }
}

// 이미지 디코딩
async function decodeList(urls = [], conc = 8) {
  const uniq = Array.from(new Set(urls.filter(Boolean)));
  let i = 0;
  while (i < uniq.length) {
    const chunk = uniq.slice(i, i + conc); i += conc;
    await Promise.all(chunk.map(u => new Promise((res) => {
      try {
        const img = new Image();
        img.onload = () => res();
        img.onerror = () => res();
        img.src = u;
        if (img.decode) img.decode().then(res).catch(res);
      } catch { res(); }
    })));
  }
}

// idle 프리패치(백그라운드) - ✅ 불필요한 지연 제거
function prefetchIdle(urls = [], conc = 10) {
  const uniq = Array.from(new Set(urls.filter(Boolean)));
  let i = 0;
  const pump = () => {
    const chunk = uniq.slice(i, i + conc); i += conc;
    Promise.all(chunk.map(u => fetch(u).catch(()=>{}))).finally(() => {
      if (i < uniq.length) (window.requestIdleCallback ? requestIdleCallback(pump) : setTimeout(pump, 0));
    });
  };
  pump(); // ✅ 즉시 실행
}

// warmup: 지원 중인 프로젝트 미리 로드
export async function warmPending(opts = {}) {
  const { uid, awaitReady } = opts;
  if (!uid) return;

  const key = keyOf(uid);
  const rkey = readyKey(uid);

  // 1) API 호출
  let items = [];
  try {
    const res = await fetch('/api/influencer/projects/my-applications?status=pending&limit=10', {
      credentials: 'include'
    });
    const j = await res.json().catch(() => ({}));
    if (res.ok && j?.ok) {
      items = Array.isArray(j.items) ? j.items : [];
      cacheSet(key, { items, total: j.total || 0 });
    }
  } catch {}

  if (!items.length) {
    cacheSet(rkey, { covers: true, detail: true });
    return;
  }

  // 2) 커버 이미지만 먼저 - ✅ 동시성 12로 증가
  const covers = items.map(x => x?.project?.cover).filter(Boolean);
  if (awaitReady === 'all' || awaitReady === 'covers') {
    await prefetchFetch(covers, 12); // ✅ 10 → 12
    await decodeList(covers, 8);
    cacheSet(rkey, { covers: true, detail: false });
  } else {
    prefetchIdle(covers, 12); // ✅ 10 → 12
    cacheSet(rkey, { covers: true, detail: false });
  }

  // 3) 갤러리 이미지 - ✅ 동시성 10/8로 증가
  const allGallery = items.flatMap(x => x?.project?.gallery || []).filter(Boolean);
  if (awaitReady === 'all') {
    await prefetchFetch(allGallery, 10); // ✅ 8 → 10
    await decodeList(allGallery, 8);      // ✅ 6 → 8
    cacheSet(rkey, { covers: true, detail: true });
  } else if (awaitReady === 'covers-decode') {
    setTimeout(() => {
      prefetchFetch(allGallery, 10).then(() => decodeList(allGallery, 8)).then(() => {
        cacheSet(rkey, { covers: true, detail: true });
      });
    }, 500);
  } else {
    prefetchIdle(allGallery, 10); // ✅ 8 → 10
    cacheSet(rkey, { covers: true, detail: true });
  }
}

// 캐시 읽기
export function readPendingWarm(uid) {
  if (!uid) return null;
  const key = keyOf(uid);
  const cached = cacheGet(key);
  return cached;
}

// 캐시 무효화
export function clearPendingCache(uid) {
  if (!ss) return;
  try {
    if (uid) {
      const key = keyOf(uid);
      const rkey = readyKey(uid);
      ss.removeItem(key);
      ss.removeItem(rkey);
    } else {
      // 모든 pending 캐시 삭제
      const keys = [];
      for (let i = 0; i < ss.length; i++) {
        const k = ss.key(i);
        if (k && (k.startsWith('INF_PENDING:') || k.startsWith('INF_PENDING_READY:'))) {
          keys.push(k);
        }
      }
      keys.forEach(k => ss.removeItem(k));
    }
  } catch {}
}

export function clearAllPendingCache() {
  clearPendingCache();
}